export default __webpack_public_path__ + "/dist/images/599921.jpg";